import { useState, useEffect } from 'react';

const useDetectDevice = () => {
    const [deviceInfo, setDeviceInfo] = useState({
        isIOS: false,
        isMacOS: false,
        isSafari: false,
        isAndroid: false,
        isMacOSChrome: false
    });

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();

        const isIOS = /iphone|ipad|ipod/.test(ua);
        const isMacOS = /macintosh|mac os x/.test(ua) && !/iphone|ipad|ipod/.test(ua);
        const isSafari = ua.indexOf('safari') !== -1 &&
            ua.indexOf('chrome') === -1 &&
            ua.indexOf('android') === -1;
        const isAndroid = /android/.test(ua);
        const isMacOSChrome = /Mac/.test(navigator.platform) && /Chrome/.test(navigator.userAgent)

        setDeviceInfo({
            isIOS,
            isMacOS,
            isSafari,
            isAndroid,
            isMacOSChrome
        });
    }, []);

    return deviceInfo;
};

export default useDetectDevice;